<template>
  <a
    v-bind="props.action"
    href="#"
    class="relative flex justify-between items-center gap-2"
    @click.prevent="handleNotificationClick(item)"
  >
    <div class="flex flex-col justify-center gap-0.5">
      <div class="flex items-center gap-1.5">
        <UserAvatar
          :name="item.notifiedBy.name"
          :image-path="item.notifiedBy.imagePath"
          avatar-class="w-6 h-6 text-xs"
        />
        <span class="text-sm">{{ item.notifiedBy.name }}</span>
      </div>
      <span class="text-xs text-gray-500">
        {{ getMentionMessage(item) }}
        <span class="text-gray-900 dark:text-gray-300">
          {{ getMentionType(item.type, item.isComment) }}
        </span>
        <span v-if="item?.commentable?.name"> in {{ item.commentable.name }}</span>
      </span>
    </div>
    <span class="text-xs text-gray-500">{{ formatNotificationDate(item.createdAt) }}</span>
    <Badge v-if="!item.readAt" severity="warn" class="absolute top-1.5 right-2" />
  </a>
</template>

<script setup>
/* global defineProps */
import UserAvatar from '@/components/admin/shared/UserAvatar.vue'
import { Badge } from 'primevue'
import { formatNotificationDate } from '@/utils/helpers'

defineProps(['item', 'props', 'handleNotificationClick'])

function getMentionType(type, isComment) {
  if (type === 'mention' && isComment) return 'comment'
  if (type === 'mention' && !isComment) return 'reply'
  return type
}

function getMentionMessage(item) {
  if (item.type === 'mention') return 'Mentioned you in a '
  if (item.type === 'reply') return 'Gave you a '
  if (item.type === 'thread') return 'Left a comment in a '
}
</script>
